<div
  class="split-view-container"
  [style.--ursa-shape-list-width]="objectListWidth"
>
  <div>
    <!-- remove this when toolbar is outside outputs -->
    <h3-cv-toolbar *ngIf="isInSplitView$ | async"></h3-cv-toolbar>
    <div
      class="outputs-container"
      [class.even-split]="isUsingEvenSplit$ | async"
    >
      @let isLeftOutputSelected = isLeftOutputSelected$ | async;
      <div class="view-container" [class.selected]="isLeftOutputSelected">
        <div
          *ngIf="!isLeftOutputSelected"
          class="view-container__curtain"
          (click)="selectPointCloudOutput($event)"
        ></div>
        <ng-container h3ViewContainer [containerId]="leftContainerId">
        </ng-container>
        @if (outputTabsEnabled) {
          <h3-output-tabs
            [outputs]="leftOutputs"
            [visibleOutputName]="pointCloudOutput?.name"
          ></h3-output-tabs>
        } @else {
          <h3-split-view-output-label
            *ngIf="pointCloudOutput?.name as outputName"
            [outputName]="outputName"
            [isSelected]="isLeftOutputSelected"
          ></h3-split-view-output-label>
        }
      </div>
      <div class="view-container" [class.selected]="!isLeftOutputSelected">
        <div
          *ngIf="isLeftOutputSelected"
          class="view-container__curtain"
          (click)="selectVideoOutput($event)"
        ></div>
        <ng-container h3ViewContainer [containerId]="rightContainerId">
        </ng-container>
        @if (outputTabsEnabled) {
          <h3-output-tabs
            [outputs]="rightOutputs"
            [visibleOutputName]="splitViewOutputName$ | async"
          ></h3-output-tabs>
        } @else {
          <h3-split-view-output-label
            *ngIf="splitViewOutputName$ | async as outputName"
            [outputName]="outputName"
            [isSelected]="!isLeftOutputSelected"
            [canSwitchOutput]="true"
            [outputs]="outputs"
          ></h3-split-view-output-label>
        }
      </div>
    </div>
  </div>
  <div
    *ngIf="splitViewOutputInjector$ | async as injector"
    class="focusable-container"
    tabindex="1"
    [style.height]="sidePanelHeight$ | async"
  >
    <h3-shape-list-and-tag-editor
      *h3Injector="injector"
    ></h3-shape-list-and-tag-editor>
  </div>
</div>
<ng-container *ngIf="(isSingleFrame$ | async) === false">
  <div
    class="timeline-container"
    *ngIf="splitViewOutputInjector$ | async as injector"
  >
    <h3-focusable-scrubber *h3Injector="injector"></h3-focusable-scrubber>
  </div>
</ng-container>
